import { UploadFileResult } from 'types/dynamic-forms/files/UploadFileResult';
import { axiosInstance } from './apiCommon';
import { UploadFileModel } from 'types/dynamic-forms/files/UploadFileModel';

export const postUploadFile = async (docId: string, model: UploadFileModel) => {
  const formData = new FormData();

  formData.append('propertyName', model.propertyName ?? '');
  formData.append('propertyId', model.propertyId);
  formData.append('docId', model.docId);
  if (model.documentTypeId) {
    formData.append('documentTypeId', model.documentTypeId);
  }
  if (model.documentLanguageCode) {
    formData.append('documentLanguageCode', model.documentLanguageCode);
  }
  if (model.file) {
    formData.append('file', model.file);
  }


  return (
    await axiosInstance.post<UploadFileResult>(`/api/v1/dynamic-forms/files/${docId}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  ).data;
};

export const deleteUploadFile = async (docId: string, fileId: string, propertyId: string) => {
  await axiosInstance.delete(`/api/v1/dynamic-forms/files/${docId}/${fileId}`, { params: { propertyId } });
};
